

exports.__esModule = true;
exports.$SidebarAddNewRoute = undefined;

require('xo-wallet-components/src/add-card/route');

require('xo-wallet-components/src/add-bank/route');

var _squid = require('squid');

var _directive = require('./directive');

var $SidebarAddNewRoute = exports.$SidebarAddNewRoute = _squid.$ComponentRoute.extend('$SidebarAddNewRoute', {

    path: 'sidebarAddNew',

    directive: _directive.$xoSidebarAddNewPageComponent,

    titleContent: 'common.addNew',

    trackingData: {
        fptiState: 'add_new_de',
        templateName: 'tray/addNew.dust',
        pageGoal: 'Add a new bank or credit card for DE specific use case',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-new',
                'pagename2': '%::fullpage-add-new:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },

    children: [{
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'token',
            sidebar: 'sidebar',
            message: 'message',
            hideparenthead: 'hideparenthead',
            billingaddressupdated: 'billingaddressupdated',
            'parent-callbacks': 'callbacks',
            'page-level': 'pageLevel',
            'show-cancel': false
        }
    }, {
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            hideparenthead: 'hideparenthead',
            'parent-callbacks': 'callbacks',
            'page-level': 'pageLevel',
            'show-cancel': false
        }
    }]
});

angular.value("$SidebarAddNewRoute", $SidebarAddNewRoute);
_squid.$ComponentRoute;

_directive.$xoSidebarAddNewPageComponent;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-add-new/route.js
// module id = ./pages/xo-sidebar-add-new/route.js
// module chunks = 0